import React, { useState } from 'react';
import './CardCreateData.scss';

import { useAuth } from '../../../../services/auth/auth-context';
import { Block3dType } from '../../../../types/block-3d-type';
import { User } from '../../../../types/models/user';
import { getDisplayDate } from '../../../../utils/dates';

import { Plate } from '../../../basic/Plate/Plate';

interface ICardCreateDataProps {
  author: User | undefined | null;
  postCreated: string;
  showHints?: boolean;
  onUsernameClick: () => void;
}

export function CardCreateData({ author, postCreated, showHints, onUsernameClick }: ICardCreateDataProps) {
  const auth = useAuth();
  const isAuthorCurrentUser = !!auth.user && !!author && auth.user.uid === author.uid;

  const [isUsernameElevated, setIsUsernameElevated] = useState(true);
  const [plateType, setPlateType]: [Block3dType, any] = useState(isAuthorCurrentUser ? 'accent' : 'neutral');

  const handleUsernameClick = () => {
    setIsUsernameElevated(false);
    setPlateType('accent');
    onUsernameClick();
  };

  const renderWhoHint = () => (
    <div className='CardCreateData__plate-hint CardCreateData__plate-hint--username'>
      <p>Author</p>
    </div>
  );

  const renderWhenHint = () => (
    <div className='CardCreateData__plate-hint'>
      <p>When</p>
    </div>
  );

  return (
    <div className='CardCreateData'>

      <div className='CardCreateData__plate-hint-wrapper'>
        { showHints ? renderWhoHint() : null }

        <Plate
          doNotCompensateBottom={true}
          isElevated={ isUsernameElevated }
          isClickable={ true }
          plateType={ plateType }
          handleMouseUp={handleUsernameClick}
        >
          <div className='CardCreateData__username' >
            { author?.name }
          </div>
        </Plate>

      </div>

      <div className='CardCreateData__plate-hint-wrapper'>
        { showHints ? renderWhenHint() : null }
        <Plate doNotCompensateBottom={true}>
          { postCreated ? getDisplayDate(postCreated) : '?' }
        </Plate>
      </div>

    </div>
  );
}
